<template>
	<teleport to="body">
		<div class="loader-backdrop" v-if="isLoading">
			<div class="loader-content">
				<svg
					ref="appleSvg"
					class="apple-svg"
					width="210mm"
					height="297mm"
					viewBox="0 0 210 297"
					version="1.1"
					id="svg5"
					inkscape:version="1.1.2 (b8e25be8, 2022-02-05)"
					sodipodi:docname="apple.svg"
					xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
					xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:svg="http://www.w3.org/2000/svg">
					<sodipodi:namedview
						id="namedview7"
						pagecolor="#ffffff"
						bordercolor="#666666"
						borderopacity="1.0"
						inkscape:pageshadow="2"
						inkscape:pageopacity="0.0"
						inkscape:pagecheckerboard="0"
						inkscape:document-units="mm"
						showgrid="false"
						inkscape:snap-nodes="false"
						inkscape:zoom="0.53561134"
						inkscape:cx="199.77172"
						inkscape:cy="673.06267"
						inkscape:window-width="1440"
						inkscape:window-height="741"
						inkscape:window-x="0"
						inkscape:window-y="25"
						inkscape:window-maximized="0"
						inkscape:current-layer="layer1" />
					<defs id="defs2" />
					<g inkscape:label="Layer 1" inkscape:groupmode="layer" id="layer1">
						<path
							id="path1364"
							style="fill: #008000; stroke-width: 0.666996"
							d="m 63.617929,74.099616 c -0.06154,-0.0018 -0.124131,-0.0012 -0.186297,0.0025 -2.639996,0.172432 -3.191866,3.233046 -3.082253,5.365931 -0.05765,5.142628 -0.72549,10.484181 0.846771,15.469906 2.431031,6.240867 6.325736,11.818137 10.89211,16.682727 38.69777,2.1112 34.07885,12.96697 38.90728,-19.404125 0.10301,-3.360479 -2.78842,-5.627301 -5.38808,-7.193658 -5.02102,-3.574102 -10.745109,-6.458276 -16.99018,-6.877104 -7.95014,-0.919636 -16.244023,-0.549236 -23.742217,-3.768794 -0.4104,-0.127812 -0.82638,-0.265152 -1.257131,-0.277479 z"
							sodipodi:nodetypes="ccccccccccc" />
						<path
							id="path1056"
							style="fill: #552200; stroke-width: 0.666996"
							d="m 110.69269,68.46576 c -4.36695,6.340726 -6.77292,13.812846 -7.78329,21.39861 -1.02328,7.774934 -1.5148,15.69588 -0.71272,23.51198 0.59097,3.66904 5.71429,6.03136 8.50635,3.15354 2.91337,-2.63614 2.07312,-6.89543 2.64268,-10.37805 0.73362,-8.539585 3.70026,-16.952568 8.57862,-23.949618 1.4182,-1.694168 1.57815,-4.4348 -0.31101,-5.850102 -2.19155,-1.593809 -4.7201,-2.807638 -6.32291,-5.099343 -1.21236,-1.462065 -2.4112,-2.935222 -3.61791,-4.402002 -0.3266,0.538345 -0.65321,1.076665 -0.97981,1.614985 z" />
						<path
							id="apple"
							style="fill: #ff0000; stroke-width: 0.666996"
							d="m 98.133125,209.648 c 5.958525,-2.29342 9.654665,-2.28845 15.102205,0.0202 9.66776,4.09727 24.0752,1.50678 35.58955,-6.39906 10.57249,-7.25916 18.45929,-20.23964 21.87777,-36.00749 1.87559,-8.65119 2.02957,-28.69878 0.27358,-35.61733 -1.91211,-7.53371 -4.85846,-12.90846 -9.75277,-17.79113 -7.76439,-7.74592 -17.24697,-10.95199 -30.98303,-10.47538 -9.47275,0.32868 -13.57106,1.6164 -19.56409,6.14724 l -3.77925,2.8572 -6.77369,-3.47304 c -11.657003,-5.97682 -23.318906,-8.12693 -33.005625,-6.08525 -13.881553,2.92584 -24.117329,12.55167 -28.447545,26.75234 -1.591692,5.21984 -1.612353,20.55314 -0.04001,29.68928 2.306799,13.40372 7.234602,26.34346 13.003517,34.14547 6.549061,8.85712 16.092551,15.42461 25.488984,17.54055 6.523745,1.4691 15.206175,0.93035 21.010399,-1.3037 z" />
					</g>
				</svg>
				<h1>Please Wait...</h1>
			</div>
		</div>
	</teleport>
</template>

<script setup>
	import { isLoading } from "@/utils/loaderBus"
</script>

<style scoped>
	.loader-backdrop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 5000;
		color: #fe7708;
	}

	.loader-content {
		text-align: center;
	}

	.apple-svg {
		width: 200px;
		height: auto;
		margin: auto;
		animation: pulse 2s infinite ease-in-out; /* Adjust duration and timing as needed */
	}

	@keyframes pulse {
		0% {
			transform: scale(0.5) rotate(0deg);
		}
		50% {
			transform: scale(1.5) rotate(180deg); /* Adjust scale factor for desired pulse size */
		}
		100% {
			transform: scale(0.5) rotate(360deg);
		}
	}
</style>
